<template>
  <div class="flex min-h-screen bg-gray-50">
    <!-- السايد بار الموحد الذي أنشأناه -->
    <UnifiedSidebar />

    <!-- المحتوى المتغير (الذي يتبدل حسب الرابط) -->
    <main class="flex-1 flex flex-col min-w-0 overflow-hidden">
      <!-- هيدر اختياري للبحث أو التنبيهات (يظهر في الشاشات الكبيرة) -->
      <header class="hidden lg:flex h-16 bg-white border-b border-gray-100 items-center px-8 justify-end">
        <div class="flex items-center space-x-4">
          <img class="w-full h-auto max-h-12 object-contain" src="/images/icons/logo_r.webp" alt="Cazalec_Logo">

        </div>
      </header>

      <!-- منطقة عرض الصفحات -->
      <div class="flex-1 overflow-y-auto p-4 lg:p-8 mt-16 lg:mt-0 ">
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </main>
  </div>
</template>

<script setup>
import UnifiedSidebar from '@/components/UnifiedSidebar.vue';
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>